'use client'

import { useState } from 'react'
import { Button } from '@indxsearch/systm'
import { Copy, Check } from '@indxsearch/pixl'
import { copyText } from '@/lib/copyText'
import styles from './InstallCommand.module.css'

type Props = {
  command: string
}

/** A one-line shell command with a copy button, the way a package page shows its install line. */
export default function InstallCommand({ command }: Props) {
  const [copied, setCopied] = useState(false)

  const copy = async () => {
    if (!(await copyText(command))) return
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className={styles.field}>
      <code className={styles.command}>{command}</code>
      <Button
        size="micro"
        variant="ghost"
        className={styles.copy}
        iconLeft={copied ? <Check /> : <Copy />}
        onClick={copy}
        aria-label={copied ? 'Copied' : `Copy "${command}"`}
        title={copied ? 'Copied' : 'Copy'}
      />
    </div>
  )
}
